import { render, staticRenderFns } from "./Substitute.vue?vue&type=template&id=9d74436a"
import script from "./Substitute.vue?vue&type=script&lang=js"
export * from "./Substitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports